import {
  faBell,
  faExclamationTriangle,
  faPerson,
  faRoute,
  faRunning,
} from '@fortawesome/free-solid-svg-icons';

const ICON_HEIGHT = 11;
const ICON_PADDING_LEFT = 3;

export const STARTER_STATUS_ICONS = {
  alert: faExclamationTriangle,
  notification: faBell,
  moving: faRunning,
  notMoving: faPerson,
  offTrack: faRoute,
};

export type StarterStatusIconKey = keyof typeof STARTER_STATUS_ICONS;

export const STATUS_ICON_COLORS = ['black', 'white'];
export type StarterStatusIconColor = (typeof STATUS_ICON_COLORS)[number];

export const getStatusIconImageId = (
  key: StarterStatusIconKey,
  color: StarterStatusIconColor,
): string => `starter-status-icon-${key}-${color}`;

export const getStatusIconImage = async (
  key: StarterStatusIconKey,
  color: StarterStatusIconColor,
): Promise<ImageBitmap> => {
  const [viewWidth, viewHeight, , , pathData] = STARTER_STATUS_ICONS[key].icon;

  const scale = ICON_HEIGHT / viewHeight;
  const width = viewWidth * scale + ICON_PADDING_LEFT;

  const canvas = document.createElement('canvas');
  const renderScale = window.devicePixelRatio || 1;
  canvas.width = Math.ceil(width * renderScale);
  canvas.height = Math.ceil(ICON_HEIGHT * renderScale);

  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Could not get 2d context');

  ctx.scale(renderScale, renderScale);
  ctx.translate(ICON_PADDING_LEFT, 0);
  ctx.scale(scale, scale);
  ctx.fillStyle = color;
  for (const path of Array.isArray(pathData) ? pathData : [pathData]) {
    ctx.fill(new Path2D(path));
  }

  return createImageBitmap(canvas);
};
